// src/utils/logoEmpresa.js
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase/firebaseConfig';

export const validarLogo = (file) => {
  if (!file) return null;

  const tiposPermitidos = [
    'image/png',
    'image/jpeg',
    'image/jpg',
    'image/webp',
  ];

  if (!tiposPermitidos.includes(file.type)) {
    return 'El logo debe ser PNG, JPG, JPEG o WEBP';
  }

  const maxSize = 1024 * 1024;

  if (file.size > maxSize) {
    return 'El logo no debe superar 1 MB';
  }

  return null;
};

export const subirLogoEmpresa = async ({ file, empId }) => {
  const error = validarLogo(file);

  if (error) {
    throw new Error(error);
  }

  const extension = file.name.split('.').pop();
  const logoPath = `logos/${empId}/logo.${extension}`;

  const storageRef = ref(storage, logoPath);

  await uploadBytes(storageRef, file, {
    contentType: file.type,
  });

  const logoUrl = await getDownloadURL(storageRef);

  return {
    logoUrl,
    logoPath,
  };
};

export const getLogoUrl = (url, version = 1) => {
  if (!url) return '/logo-default.png';

  return url.includes('?')
    ? `${url}&v=${version || 1}`
    : `${url}?v=${version || 1}`;
};